import { LuFileText, LuHistory } from 'react-icons/lu';
import { Tabs } from '../../ui/Navigation';
import { useStrings } from '../../tenant/TenantProvider';

export function StatementPane({ tab, onTabChange, children }) {
  const t = useStrings();
  return (
    <section className="pane statement-pane">
      <div className="pane__header">
        <Tabs
          label={t('workspace.description')}
          value={tab}
          onChange={onTabChange}
          tabs={[
            { id: 'description', label: t('workspace.description'), icon: LuFileText },
            { id: 'submissions', label: t('workspace.submissions'), icon: LuHistory },
          ]}
        />
      </div>
      <div className="pane__body pane__body--reading">{children}</div>
    </section>
  );
}
